import React from 'react';
import { StimulizeDataAnalysisApp } from '../../stimulize-data-analysis/StimulizeDataAnalysisApp';

/** Data analysis workflow (Data / Analysis / Plot). */
export function DataAnalysisPage() {
  return (
    <div className="data-analysis-page">
      <StimulizeDataAnalysisApp />
    </div>
  );
}
